// extracted by mini-css-extract-plugin
export default {"container":"Flag__container-xNODP"};